'use strict';

var _ = require('lodash');
var DemandFilterFactory = function DemandFilterFactory() {
  function DemandFilter(sourceType, targetType) {
    this.sourceType = sourceType;
    this.targetType = targetType;
    this.filterStrategies = [];
  }
  DemandFilter.constructor = DemandFilter;
  DemandFilter.prototype.canFilter = function (sourceType, targetType) {
    if (Array.isArray(this.sourceType)) {
      return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
    } else {
      return this.sourceType === sourceType && this.targetType === targetType;
    }
  };
  DemandFilter.prototype.registerStrategies = function (strategies, methods) {
    for (var c = 0, l = strategies.length; c < l; c++) {
      var implementsStrategy = doesImplementsStrategy(strategies[c].prototype, methods);
      if (implementsStrategy) {
        var Strategy = strategies[c];
        var strategyInstance = new Strategy();
        this.filterStrategies.push(strategyInstance);
      }
    }
  };
  DemandFilter.prototype.registerFilters = function (filters) {
    this.registerStrategies(filters, ['canFilter', 'filter', 'getFilterType']);
  };
  DemandFilter.prototype.getFilterStrategies = function (filters) {
    var filterStrategies,
      filterMap = {};
    filters.filter(function (filter) {
      return _.every(filter.filterArguments, function (argument) {
        return Array.isArray(argument) && argument.length > 0;
      });
    }).forEach(function (filter) {
      filterMap[filter.filterType] = filter.filterArguments;
    });
    var self = this;
    var filtersMap = Object.keys(filterMap);
    var filtersMapLength = filtersMap.length;
    filterStrategies = _.filter(self.filterStrategies, function (filterStrategy) {
      for (var i = 0; i < filtersMapLength; i++) {
        var filterName = filtersMap[i];
        if (Array.isArray(self.sourceType)) {
          for (var n = 0, sourceTypeLength = self.sourceType.length; n < sourceTypeLength; n++) {
            var currentSourceType = self.sourceType[n];
            if (filterStrategy && filterStrategy.canFilter(currentSourceType, filterName)) {
              return true;
            }
          }
        } else if (filterStrategy && filterStrategy.canFilter(self.sourceType, filterName)) {
          return true;
        }
      }
      return false;
    });
    return _.chain(filterStrategies).sortBy('priority').reverse().transform(function (result, filterStrategy) {
      return result.push({
        filterFunction: filterStrategy.filter,
        filter: filterStrategy,
        filterArguments: filterMap[filterStrategy.getFilterType()]
      });
    }).value();
  };
  DemandFilter.prototype.filter = function (data, filters) {
    if (!Array.isArray(filters) || _.isEmpty(filters)) {
      return data;
    }
    var filterStrategies = this.getFilterStrategies(filters);
    return _.reduce(filterStrategies, function (filteredData, filterStrategy) {
      var filterArgs = Array.isArray(filterStrategy.filterArguments) ? filterStrategy.filterArguments.slice() : [filterStrategy.filterArguments];
      filterArgs.unshift(filteredData);
      return filterStrategy.filterFunction.apply(filterStrategy.filter, filterArgs);
    }, data);
  };
  function doesImplementsStrategy(prototype, methods) {
    return _.every(methods, function (method) {
      return typeof prototype[method] === 'function';
    });
  }
  return DemandFilter;
};
module.exports = DemandFilterFactory;